export default __webpack_public_path__ + "static/negative-former-eksempel3-a105372abbf853cd8822578e9fef6ba2.png";